import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  IconButton,
  MenuItem
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import colors from '../theme/Colors';
import { api } from '../helpers/apiRequest'; // ✅ using your api wrapper
import { toast } from 'react-toastify';

const PaymentDialog = ({ open, onClose, order,refresh }) => {
  const [paymentType, setPaymentType] = useState('partial');
  const [amount, setAmount] = useState('');

  // auto-fill full pay amount when selected
  useEffect(() => {
    if (paymentType === 'full' && order?.final_price) {
      setAmount(order.final_price);
    } else {
      setAmount('');
    }
  }, [paymentType, order]);

  const handleSave = async () => {
    try {
      if (!order?._id && !order?.orderId) {
        toast.error("Order ID not found");
        return;
      }
      if (Number(amount)>order?.balance) {
        toast.warn("Amount must be less than or equals to the balance Amount!!!");
        return;
      }

      const payload = {
        orderId: order?.orderId || order?._id, // adapt depending on backend response
        amount: paymentType === 'full' ? order.final_price : Number(amount),
        date: new Date().toISOString(),
      };

      const response = await api.put(`/orders/update-amount-paid`, payload);

      toast.success("Payment recorded successfully!");
      onClose();
      setPaymentType('partial');
      setAmount('');
      await refresh();
      return response.data;
    } catch (error) {
      console.error("Error saving payment:", error);
      toast.error("Failed to save payment");
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle
        sx={{ fontSize: { xs: '1rem', sm: '1.2rem' }, position: 'relative' }}
      >
        Add Payment
        <IconButton
          onClick={onClose}
          sx={{ position: 'absolute', right: 8, top: 8, color: 'black' }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ pt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
        {/* Dropdown for Payment Type */}
        <TextField
          select
          label="Payment Type"
          value={paymentType}
          onChange={(e) => setPaymentType(e.target.value)}
          fullWidth
        >
          <MenuItem value="partial">Partial Pay</MenuItem>
          {order?.amount_paid<=0&&<MenuItem value="full">Full Pay</MenuItem>}
        </TextField>

        {/* Amount Input */}
        <TextField
          label="Amount"
          type="number"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          fullWidth
          disabled={paymentType === 'full'}
        />
      </DialogContent>

      <DialogActions
        sx={{
          p: { xs: 1, sm: 1.5 },
          flexDirection: { xs: 'column', sm: 'row' },
          gap: { xs: 1, sm: 0 },
          justifyContent: 'flex-end',
        }}
      >
        <Button
          onClick={onClose}
          sx={{
            width: { xs: '100%', sm: 'auto' },
            fontSize: { xs: '0.75rem', sm: '0.875rem' },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSave}
          sx={{
            backgroundColor: colors.primary,
            color: 'black',
            '&:hover': {
              backgroundColor: '#FFC107',
              opacity: 0.9,
            },
            width: { xs: '100%', sm: 'auto' },
            fontSize: { xs: '0.75rem', sm: '0.875rem' },
          }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PaymentDialog;
